export default __webpack_public_path__ + "static/media/246.3b9ecc19.png";